module.exports = "<app-weather-card [@showUpElement] [weather]=\"weatherService.weather$ | async\"></app-weather-card>\n"